import { Swiper, Controller, Thumbs, Navigation } from 'swiper';
import elementExists from '../../core/utils/element-exists';
import eventBus from '../../core/services/event-bus';

const ProductImagesSwiper = function () {
	Swiper.use([Thumbs, Controller, Navigation]);

	const swiperProduct = document.querySelector('.product-single__images');
	if (elementExists(swiperProduct)) {
		const swiperProductThumb = swiperProduct.querySelector(
			'.swiper-product-thumbs',
		);
		const swiperProductMain = swiperProduct.querySelector(
			'.swiper-product-main',
		);
		const imagesModal = swiperProduct.querySelector('.modal--images');
		const swiperModalThumb = imagesModal.querySelector(
			'.swiper-product-thumbs',
		);
		const swiperModalMain = imagesModal.querySelector(
			'.swiper-product-main',
		);

        const mainImages = swiperProduct.querySelector('.main-images');
        const modalImages = swiperProduct.querySelector('.modal--images');

		let swiperThumbs = null;
		let swiperMain = null;
		let modalThumbs = null;
		let modalMain = null;
		const hasThumbs = elementExists(swiperProductThumb);

		if (elementExists(swiperProductMain)) {
			if (hasThumbs) {
				swiperThumbs = new Swiper(swiperProductThumb, {
					slidesPerView: 4,
					spaceBetween: 8,
					slideToClickedSlide: true,
					freeMode: true,
					watchSlidesProgress: true,
					// loop: true,
					breakpoints: {
						768: {
							slidesPerView: 5,
						},
					}
				});
			}

			swiperMain = new Swiper(swiperProductMain, {
				slidesPerView: 1,
				spaceBetween: 0,
				allowTouchMove: true,
				// loop: true,
				thumbs: {
					swiper: swiperThumbs,
				},
				navigation: {
					nextEl: mainImages.querySelector(
						'.swiper-button-next',
					),
					prevEl: mainImages.querySelector(
						'.swiper-button-prev',
					),
				},
			});

			window.addEventListener('resize', function () {
				swiperMain.update();
				swiperThumbs?.update();
			});

			eventBus.on(eventBus.types.OptionsSelected, function (event) {
				const variantId = event.detail.id;
				const imageSlides = swiperProductMain.querySelectorAll(
					'.swiper-slide:not(.swiper-slide-duplicate',
				);
				imageSlides.forEach((el) => {
					const data = el.dataset;
					if (data.variantIds) {
						if (data.variantIds.indexOf(variantId) > -1) {
							swiperMain.slideToLoop(data.swiperSlideIndex, 0);
						}
					}
				});
			});
		}
		document.body.append(imagesModal);

		if (hasThumbs) {
			modalThumbs = new Swiper(swiperModalThumb, {
				slidesPerView: 4,
				spaceBetween: 8,
				slideToClickedSlide: true,
				freeMode: true,
				watchSlidesProgress: true,
				// loop: true,
				breakpoints: {
					768: {
						slidesPerView: 5,
					},
				}
			});
		}

		modalMain = new Swiper(swiperModalMain, {
			slidesPerView: 1,
			spaceBetween: 0,
			allowTouchMove: true,
			// loop: true,
			thumbs: {
				swiper: modalThumbs,
			},
			navigation: {
				nextEl: modalImages.querySelector('.swiper-button-next'),
				prevEl: modalImages.querySelector('.swiper-button-prev'),
			},
		});

		imagesModal.addEventListener('shown.bs.modal', function () {
			modalMain.slideToLoop(swiperMain.realIndex, 0);
		});
	}
};

export default ProductImagesSwiper;
